export var ButtonColor = {
  Primary: 'primary',
  Secondary: 'secondary',
  Link: 'link',
  Error: 'error'
};